import { V2HighEnergyDeviceV2EnergyMonitoringPostResponse } from '@maxtropy/device-customer-apis-v2';
import dayjs, { Dayjs } from 'dayjs';

export enum WorkStatusType {
  SHUT = 1,
  STANDBY = 2,
  RUN = 3,
}

export enum CompareType {
  DEVICE = '1',
  INDICATOR = '2',
}
export enum MeasurementType {
  ACCUM = 1,
  INSTANT = 2,
}
// 基线周期
export enum DateType {
  YEAR = 'Y',
  MONTH = 'M',
  WEEK = 'W',
  DAY = 'D',
}

export const WorkStatusDisplay = {
  [WorkStatusType.SHUT]: '停机用能',
  [WorkStatusType.STANDBY]: '待机用能',
  [WorkStatusType.RUN]: '运行用能',
};

export const CompareTypeDisplay = {
  [CompareType.DEVICE]: '设备对比',
  [CompareType.INDICATOR]: '指标对比',
};

export const DateTypeDisplay = {
  [DateType.YEAR]: '年',
  [DateType.MONTH]: '月',
  [DateType.WEEK]: '周',
  [DateType.DAY]: '日',
};

export const OnDateTypeDisplay = {
  [DateType.YEAR]: '年',
  [DateType.MONTH]: '月',
  [DateType.WEEK]: '周',
  [DateType.DAY]: '日',
};

export const momTitleFunc = (timeResolution: DateType) => {
  switch (timeResolution) {
    case DateType.DAY:
      return '环比昨日';
    case DateType.WEEK:
      return '环比上周';
    case DateType.MONTH:
      return '环比上月';
    case DateType.YEAR:
      return '环比上年';
    default:
      return '环比';
  }
};

export enum StateTimeType {
  USERATIO = 0,
  STANDBY = 1,
  SHUTDOWN = 2,
  OPERATION = 3,
  ENERGY = 4,
  MONITORING = 5,
}

export const StateTimeDisplay = {
  [StateTimeType.USERATIO]: '设备利用率',
  [StateTimeType.STANDBY]: '待机时长',
  [StateTimeType.SHUTDOWN]: '停机时长',
  [StateTimeType.OPERATION]: '运行时长',
  [StateTimeType.ENERGY]: '能源介质',
  [StateTimeType.MONITORING]: '监测指标数据属性',
};

export const formatNumber = (num: number | undefined) => {
  if (!num) return `--`;
  return num.toFixed(2);
};

export const icons = [
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiM4QkQ0RUEiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiNCNkU3N0YiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiNGRjk4NkEiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiNGRjZEMkMiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
  'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjYycHgiIGhlaWdodD0iMzdweCIgdmlld0JveD0iMCAwIDYyIDM3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0NC4xICg0MTQ1NSkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAiIGZpbGw9IiM0QTkwRTIiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiB4PSIwIiB5PSIwIiB3aWR0aD0iNjIiIGhlaWdodD0iMjYiPjwvcmVjdD4KICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyOS41MDAwMDAsIDMxLjAwMDAwMCkgc2NhbGUoMSwgLTEpIHRyYW5zbGF0ZSgtMjkuNTAwMDAwLCAtMzEuMDAwMDAwKSAiIHBvaW50cz0iMjkuNSAyNSA0MCAzNyAxOSAzNyI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+',
];
export const groups = {
  相电压: [10001, 10002, 10003],
  线电压: [10004, 10005, 10006],
  相电流: [10008, 10009, 10010],
};
export enum EPricePeakType {
  // 尖
  SUMMIT = 1,
  // 峰
  PEAK,
  // 平
  PLAIN,
  // 谷
  VALLEY,
}
export interface AllEPriceTime {
  [key: string | number]: EPriceTime[];
}

export interface EPriceTime {
  type?: EPricePeakType;
  intervalStart: number;
  intervalEnd: number;
}
export const aagetAllDates = (startTime: number, endTime: number) => {
  const diff = dayjs(endTime).diff(dayjs(startTime), 'd');
  return Array.from({ length: diff + 1 }, (_, i) => dayjs(startTime).add(i, 'd').valueOf());
};

// 获取EPriceTimes（后端直接返回key为日期的时间戳）
export const getEPriceTimesByDay = (dates: number[], allEprices: AllEPriceTime) => {
  let times: EPriceTime[] = [];
  if (Object.keys(allEprices).length !== 0) {
    dates.forEach((d, i) => {
      const value = allEprices[dayjs(d).valueOf()];
      value?.forEach(f => {
        times.push({
          type: f.type,
          intervalStart: f.intervalStart + i * 48,
          intervalEnd: f.intervalEnd + i * 48,
        });
      });
    });
  }
  times.sort((a, b) => a.intervalStart - b.intervalStart);
  return times;
};

export const E_PRICE_PEAK_TYPE_COLORS_MAP = {
  [EPricePeakType.SUMMIT]: '#FF6D2C',
  [EPricePeakType.PEAK]: '#CE90D1',
  [EPricePeakType.PLAIN]: '#0DB6D9',
  [EPricePeakType.VALLEY]: '#63BC7F',
};

//获取两个时间之前的所有日期
export const getAllDates = (startTime: number, endTime: number) => {
  const diff = dayjs(endTime).diff(dayjs(startTime), 'd');
  let dates = [startTime];
  for (let i = 1; i <= diff; i++) {
    dates.push(dayjs(startTime).add(i, 'd').valueOf());
  }
  return dates;
};

export const getMarkAreaData = (
  ePriceTimes?: EPriceTime[],
  datas?: V2HighEnergyDeviceV2EnergyMonitoringPostResponse
) => {
  return ePriceTimes?.map(item => {
    const { intervalStart, intervalEnd, type } = item;
    const color = `${E_PRICE_PEAK_TYPE_COLORS_MAP[type!]}20`;
    const startTime = datas?.totalData?.summitDataList?.find((_: any, index: number) => index === intervalStart)?.time;
    const endTime = datas?.totalData?.summitDataList?.find((_: any, index: number) => index === intervalEnd + 1)?.time;
    return [
      {
        xAxis: startTime,
        itemStyle: {
          color,
        },
      },
      {
        xAxis: endTime,
      },
    ];
  });
};

export const overallGetTime = (mode: DateType, date: Dayjs) => {
  switch (mode) {
    case DateType.DAY:
      return {
        startTime: dayjs(date).startOf('day').valueOf(),
        endTime: dayjs(date).endOf('day').valueOf(),
      };
    case DateType.WEEK:
      return {
        startTime: dayjs(date).startOf('week').valueOf(),
        endTime: dayjs(date).endOf('week').valueOf(),
      };
    case DateType.MONTH:
      return {
        startTime: dayjs(date).startOf('month').valueOf(),
        endTime: dayjs(date).endOf('month').valueOf(),
      };
    case DateType.YEAR:
      return {
        startTime: dayjs(date).startOf('year').valueOf(),
        endTime: dayjs(date).endOf('year').valueOf(),
      };
    default:
      return {
        startTime: dayjs(date).startOf('day').valueOf(),
        endTime: dayjs(date).endOf('day').valueOf(),
      };
  }
};

export const getCommonMarkPint = (unit?: string, name?: string) => {
  return {
    label: {
      show: true,
      offset: [0, -4],
    },
    emphasis: {
      show: true,
      offset: [0, -4],
    },
    symbolSize: [name ? 160 : 120, 26],
    symbolOffset: [0, -13],
    data: [
      {
        type: 'max',
        name: '最高',
        symbol: `image://${icons[3]}`,
        itemStyle: {
          color: '#FF4D4F',
          opacity: 0.75,
        },
        label: {
          formatter: function (data: any) {
            return `${name ?? ''}最高：${data.value.toFixed(2)}${unit}`;
          },
        },
      },
      {
        type: 'min',
        name: '最低',
        symbol: `image://${icons[4]}`,
        itemStyle: {
          color: '#00ADFF',
          opacity: 0.75,
        },
        label: {
          formatter: function (data: any) {
            return `${name ?? ''}最低：${data.value.toFixed(2)}${unit}`;
          },
        },
      },
    ],
    itemStyle: {
      normal: {
        color: '#d6a223',
      },
    },
  };
};

export const xLabel = (v: string) => {
  if (v === DateType.MONTH || v === DateType.WEEK) {
    return 'YYYY-MM-DD';
  } else if (v === DateType.YEAR) {
    return 'YYYY-MM';
  } else {
    return 'HH:mm';
  }
};
